import { Box, Button, Grid, Typography } from "@mui/material";

import AgentForm from "./AgentForm";

function CreateAgent() {
  return (
    <>
      {" "}
      <Box>
        <AgentForm />
      </Box>
    </>
  );
}

export default CreateAgent;
